import { Injectable } from '@angular/core';
import { PluginInjectorApplicationPlugin, IMenuItemPermissions, PluginInjectorService} from 'core-client/api';
import { AdministrationService } from './administration/administration.service'
import { WidgetControlService } from './widget-control/widget-control.service'
import { MenuItemControlService } from './menu-item-control/menu-item-control.service'
import { DashboardService } from './dashboard/dashboard.service'
import { ThemeSwitcherService } from './theme-switcher/theme-switcher.service'
import { UserProfileService } from './user-profile/user-profile.service';

@Injectable({
  providedIn: 'root'
})
export class CorePluginService {
  private plugin: PluginInjectorApplicationPlugin.IApplicationPlugin = <PluginInjectorApplicationPlugin.IApplicationPlugin>{}

  constructor(
    private readonly pluginInjectorService: PluginInjectorService,
    private readonly administrationService: AdministrationService,
		private readonly userProfileService: UserProfileService,
    private readonly widgetControlService: WidgetControlService,
    private readonly menuItemControlService: MenuItemControlService,
    private readonly dashboardService: DashboardService,
    private readonly themeSwitcherService: ThemeSwitcherService
  ) {
    this.plugin.name = 'CORE_PLUGIN';
    this.plugin.enabled = true;
    this.plugin.corePlugin = true;
    this.plugin.menuItems = [];
    this.plugin.description = 'Core Plugin including multiple modules';
    this.plugin.permissions = {
      menuitem_permissions: this.getModulePermissions()
    };
    this.plugin.version = '0.0.1';
  }

  async setup(): Promise<void> {
    await this.initPlugin();
  }

  private async initPlugin(): Promise<void> {
    this.addHeaderNavigationMenuItems();
    this.pluginInjectorService.register(this.plugin);
  }

  private getModulePermissions(): IMenuItemPermissions {
    const adminModulePermissions = this.administrationService.getMenuItemPermissions();
	  const userProfileModulePermissions = this.userProfileService.getMenuItemPermissions();
    const dashboardModulePermissions = this.dashboardService.getMenuItemPermissions();
	  const widgetModulePermissions = this.widgetControlService.getMenuItemPermissions();
	  const menuItemModulePermissions = this.menuItemControlService.getMenuItemPermissions();

    return  { ...adminModulePermissions, ...userProfileModulePermissions, ...dashboardModulePermissions, ...widgetModulePermissions, ...menuItemModulePermissions };
  }

  addHeaderNavigationMenuItems(): void {
    if (this.plugin?.menuItems) {
      this.plugin.menuItems = this.menuItemControlService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true
      );
      this.plugin.menuItems = this.widgetControlService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true
      );
      this.plugin.menuItems = this.dashboardService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true
      );
      this.plugin.menuItems = this.userProfileService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true
      );
      this.plugin.menuItems = this.themeSwitcherService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          true,
          false
      );
      this.plugin.menuItems = this.administrationService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          true,
          false
      );
    }
  }
}
